/**
 * 门户框架专属顶栏/菜单默认色（与 analysisSet LAYOUT_PRESETS 保持一致）
 */
export const FRAME_COLOR_PRESETS: Record<string, { headerBg: string; menuBg: string }> = {
  technology: {
    headerBg: '#ffffff',
    menuBg: '#ffffff',
  },
  classicBlue: {
    headerBg: '#1F58A7',
    menuBg: '#1F58A7',
  },
};

export function getFrameColorPreset(layoutId?: string | null) {
  if (!layoutId) {
    return null;
  }
  return FRAME_COLOR_PRESETS[layoutId] || null;
}
